import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { API_ENDPOINTS } from '../../../constants/api';
import { competitionsQueryKeys } from '../constants/competitionsQueryKeys';
import type { CompetitionsListApiPayload, CompetitionSummary } from '../types/competitions.types';

const STALE_TIME_COMPETITIONS_LIST_MS = 60_000;
const GC_TIME_COMPETITIONS_LIST_MS = 30 * 60_000;

export function useCompetitionsListQuery(enabled: boolean = true) {
  const apiClient = useApiClient();

  return useQuery<CompetitionSummary[]>({
    queryKey: competitionsQueryKeys.list(),
    queryFn: async () => {
      const response = await apiClient<CompetitionsListApiPayload>(API_ENDPOINTS.competitions.list);
      const payload = response.data;
      if (!payload.success) {
        throw new Error(payload.error || 'Failed to load competitions');
      }
      return payload.data.competitions;
    },
    enabled,
    staleTime: STALE_TIME_COMPETITIONS_LIST_MS,
    gcTime: GC_TIME_COMPETITIONS_LIST_MS,
    refetchOnWindowFocus: false,
  });
}
